export function BudgetUser({
    apikey,
    uid,
    name,
    email,
    distributorUid,
    isManager,
    readOnly,
} = {}) {
    return {
        apikey,
        uid,
        name,
        email,
        distributorUid,
        isManager,
        readOnly,
    };
}